<template>
  <div class="seestadtbot-search">
    <h1><span class="hidden-mobile">Seestadt-</span>Verzeichnis</h1>

    <sk-search ref="search"></sk-search>

    <template v-if="showSuggestions">
      <section class="query-suggestions">
        <h2>Populäre Suchbegriffe</h2>
        <ul class="suggestion-list">
          <li v-for="query in demoQueries" :key="query">
            <span @click="setQuery(query)" class="button">{{ query }}</span>
          </li>
        </ul>
      </section>

      <section class="promotions" v-if="showPromotions">
        <h2>Aktuelle Angebote und Aktionen</h2>
        <sk-promotions></sk-promotions>
      </section>

      <section>
        <h2>Die Seestadt erkunden</h2>
        <ul class="suggestion-list">
          <li class="map-link"><router-link :to="{ name: 'sk-map'}" class="button">Alles auf einer Karte</router-link></li>
          <li><router-link :to="{ name: 'sk-map', query: { tag: '3420 :: einkaufen + genießen' } }" class="button">Einkaufen + Genießen</router-link></li>
          <li><router-link :to="{ name: 'sk-map', query: { tag: '3420 :: gesundheit + freizeit' } }" class="button">Gesundheit + Freizeit</router-link></li>
          <li><router-link :to="{ name: 'sk-map', query: { tag: '3420 :: bildung + kultur' } }" class="button">Bildung + Kultur</router-link></li>
          <li><router-link :to="{ name: 'sk-map', query: { tag: '3420 :: wohnen + arbeiten' } }" class="button">Wohnen + Arbeiten</router-link></li>
          <li><router-link :to="{ name: 'sk-map', query: { tag: '3420 :: nachbarschaft' } }" class="button">Nachbarschaft</router-link></li>
          <li><router-link :to="{ name: 'sk-map', query: { tag: '3420 :: mobilität' } }" class="button">Mobilität</router-link></li>
          <li><router-link :to="{ name: 'sk-overview' }" class="button">Alles in einer Liste</router-link></li>
        </ul>
      </section>

      <section class="something-missing">
        <p>
          Fehlt dein Unternehmen oder Geschäft? Hast du einen Verein oder bietest ein Service in der Seestadt an?
          Seestadt.bot basiert auf dem StadtKatalog, wo du dich einfach einträgst und damit auch hier erscheinst.
        </p>
        <p class="suggest-stadtkatalog-entry">
          <a :href="proposalUrl" class="button">
            Eintrag vorschlagen
          </a>
        </p>
      </section>
    </template>

  </div>
</template>

<script>
  import {mapState} from "vuex";
  const {siteName} = STADTKATALOG_CONFIG;
  import StadtKatalogSearch from "@/components/StadtKatalogSearch";
  import StadtKatalogPromotions from "@/components/StadtKatalogPromotions";

  export default {
    name: "seestadtbot-search",
    components: {
      "sk-search": StadtKatalogSearch,
      "sk-promotions": StadtKatalogPromotions
    },
    data () {
      return {
        demoQueries: ["Arzt", "Apotheke", "Restaurant", "Bäckerei", "Buchhandlung", "Spar", "Coworking"]
      }
    },
    computed: {
      ...mapState([
        "geoFenceName",
        "totalHits",
        "promotionEntries"
      ]),
      showSuggestions: function() {
        return this.totalHits <= 0;
      },
      showPromotions: function() {
        return window.__PRERENDER__ === undefined && this.promotionEntries.length > 0;
      },
      proposalUrl: function() {
        return `https://app.stadtkatalog.org/stk/proposeEntry${this.geoFenceName !== null ? "?geoFenceName=" + this.geoFenceName : ""}`;
      }
    },
    methods: {
      setQuery(query) {
        this.$store.commit("setQuery", query);
        this.$refs.search.queryStadtKatalog();
        this.$refs.search.focusSearchField();
      }
    },
    created() {
      document.title = "Seestadt-Verzeichnis - " + siteName;
      this.$store.commit("resetQueryStates");
      this.$store.dispatch("updatePromotionEntries");
    }
  }
</script>

<style lang="scss">
  .seestadtbot-search {
    > h1 {
      padding-top: 5px;
      text-align: center;
    }

    .search-wrapper {
      max-width: 54rem;
      margin: 0 auto;
    }

    section {
      margin: 3rem 0;
      padding: 0 3rem;

      h1, h2 {
        text-align: center;
      }

      p {
        line-height: 1.375rem;
      }
    }

    .something-missing {
      .suggest-stadtkatalog-entry {
        text-align: center;

        .button {
          font-weight: 600;
          padding: 0.75rem 1.25rem;
        }
      }
    }

    .suggestion-list {
      margin: 0;
      padding: 0;
      display: flex;
      flex-wrap: wrap;
      list-style: none;
      justify-content: space-around;

      li {
        margin-bottom: 0.75rem;
        cursor: pointer;

        .button {
          display: inline-block;
        }
      }

      .map-link .button::before {
        content: "";
        background-image: url("../../assets/map_icon.svg");
        background-repeat: no-repeat;
        background-size: 100%;
        display: inline-block;
        height: 1rem;
        width: 1rem;
        position: relative;
        top: 1px;
        margin-right: 0.3125rem;
      }
    }

    @media (max-width: 50rem) {
      section {
        margin: 3rem 0;
        padding: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/seestadtbot/SeestadtBotSearch.vue